const LOADING = "LOADING";
const RESPONSE_COMPLETE = "RESPONSE_COMPLETE";
const SEARCH = "SEARCH";
const ERROR = "ERROR";

const actionTypes = { LOADING, RESPONSE_COMPLETE, SEARCH, ERROR };

export default actionTypes;
